import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Popper from '@material-ui/core/Popper';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import Zoom from '@material-ui/core/Zoom';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';

const arrowSize = 10;

const useStyles = makeStyles((theme) => ({
  popper: {
    zIndex: theme.zIndex.tooltip,
    filter: 'drop-shadow(1px 2px 2px rgba(0,0,0,.5))',
    '&[x-placement*="left"] .arrow': {
      right: 0,
      marginRight: - arrowSize - arrowSize + 1,
      borderTopColor: 'transparent',
      borderRightColor: 'transparent',
      borderBottomColor: 'transparent',
    },
    '&[x-placement*="top"] .arrow': {
      bottom: 0,
      marginBottom: - arrowSize - arrowSize + 1,
      borderLeftColor: 'transparent',
      borderRightColor: 'transparent',
      borderBottomColor: 'transparent',
    },
    '&[x-placement*="right"] .arrow': {
      left: 0,
      marginLeft: - arrowSize - arrowSize + 1,
      borderLeftColor: 'transparent',
      borderTopColor: 'transparent',
      borderBottomColor: 'transparent',
    },
    '&[x-placement*="bottom"] .arrow': {
      top: 0,
      marginTop: - arrowSize - arrowSize + 1,
      borderLeftColor: 'transparent',
      borderTopColor: 'transparent',
      borderRightColor: 'transparent',
    },
  },
  arrow: {
    zIndex: theme.zIndex.tooltip,
    position: 'absolute',
    borderColor: theme.palette.background.paper,
    borderStyle: 'solid',
    borderWidth: arrowSize,
  },
  content: {
    margin: 0,
    padding: theme.spacing(2),
  },
}));

const QPopper = (props) => {
  const {modifiers, onClickAway, ...otherProps} = props;
  const classes = useStyles(props);
  const [arrowRef, setArrowRef] = useState();

  return props.anchorEl ? (
    <Popper
      className={classes.popper}
      keepMounted={false}
      disablePortal={false}
      modifiers={{
        flip: {
          enabled: true,
        },
        preventOverflow: {
          enabled: true,
          boundariesElement: 'scrollParent',
        },
        arrow: {
          enabled: true,
          element: arrowRef,
        },
        ...modifiers,
      }}
      {...otherProps}
      transition
    >
      {({TransitionProps}) => (
        <ClickAwayListener onClickAway={onClickAway}>
          <Zoom {...TransitionProps} timeout={350}>
            <div>
              <span
                className={classNames(classes.arrow, 'arrow')}
                ref={(ref) => setArrowRef(ref)}
              />
              <Paper elevation={0} className={classes.content}>
                {props.children}
              </Paper>
            </div>
          </Zoom>
        </ClickAwayListener>
      )}
    </Popper>
  ) : null;
};

QPopper.propTypes = {
  anchorEl: PropTypes.object,
  modifiers: PropTypes.object,
  children: PropTypes.any,
  open: PropTypes.bool,
  onClickAway: PropTypes.func,
};

export default QPopper;
